import isPropValid from '@emotion/is-prop-valid';

/**
 * styled-components v6 dropped v5's automatic prop filtering, so styling-only props
 * (hover, alignX, spacing, ...) leak onto DOM nodes and trigger React warnings. Restore
 * the old behaviour: only forward valid HTML attributes to host (string) elements, and
 * forward everything to custom components.
 */
export const shouldForwardProp = (prop: string, element: unknown): boolean =>
  typeof element === 'string' ? isPropValid(prop) : true;
